module.exports = __webpack_public_path__ + "img/Pista_0119_I.b3d69e02.png";